module.exports = __webpack_public_path__ + "img/TrustBy_Medemass.837e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Medemass.png
// module id = 607
// module chunks = 5